<template>
    <div class="booking__rooms">
        <table class="booking__rooms__list">
            <div v-if="room.HasCampaign" class="booking__rooms__list__campaign-column mobile-only">
                {{room.CampaignMobileText}}
            </div>

            <thead>
                <tr>
                    <th class="booking__rooms__list--header-checkbox"></th>
                    <th class="booking__rooms__list--header-room-size">{{dictionary.BookingRoomSize}}</th>
                    <th v-if="room.HasCampaign" class="booking__rooms__list--header-campaign desktop-only"></th>
                    <th class="booking__rooms__list--header-price-monthly">{{dictionary.BookingRoomPricePerMonth}}</th>
                    <th class="booking__rooms__list--header-price-daily">{{dictionary.BookingRoomPricePerDay}}</th>
                    <th class="booking__rooms__list--header-price-inclusive desktop-only">
                        <h4><strong>Inklusiv i prisen:</strong></h4><br />
                        <p>&#10004; Alarm</p><br />
                        <p>&#10004; Forsikring</p><br />
                        <p>&#10004; 24/7 adgang</p><br />
                        <p>&#10004; Nul depositum</p><br />
                        <p>&#10004; Nul binding</p><br />
                        <p>&#10004; Opsigelse fra dag til dag</p>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="booking__rooms__list__room-row selected">
                    <td class="booking__rooms__list__checkbox">
                        <input type="radio" class="checkbox" name="roomSize" checked />
                    </td>
                    <td class="booking__rooms__list-size">
                        <span class="booking__rooms_size-pretext">Rum:</span>
                        <div class="booking__rooms__list-size-wrapper">
                            <div class="booking__rooms_size-left">{{room.RoomSize}} m<sup>2</sup></div>
                            <div class="booking__rooms_divider">
                                /
                            </div>
                            <div class="booking__rooms_size-right">
                                {{room.RoomVolume}} m<sup>3</sup>
                            </div>
                        </div>
                    </td>
                    <td v-if="room.HasCampaign" class="booking__rooms__list__campaign-column desktop-only">
                        {{room.CampaignDesktopText}}
                    </td>
                    <td class="booking__rooms__list-price-monthly">

                        <div v-if="room.HasCampaign" class="booking__rooms__list-price-monthly-campaign"><span class="booking__rooms__list__campaign-column">{{room.CampaignPrice}} kr. </span> pr. md. i rabatperioden.</div>
                        <div v-if="room.HasCampaign" class="booking__rooms__list-price-monthly-campaign">Normalpris {{room.Price}} kr. pr. md.</div>

                        <div v-if="!room.HasCampaign" class="booking__rooms__list-price-monthly">{{room.Price}} kr.</div>

                    </td>
                    <td class="booking__rooms__list-price-daily" :class="{'booking__rooms__list__campaign-column' : room.HasCampaign}">{{room.DailyPrice}} kr.</td>
                    <td class="booking__rooms__list-price-inclusive-price desktop-only">0 kr.</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="5" class="booking__rooms__size-info">
                        {{dictionary.BookingRoomFooterPriceCalc}}<br />
                        {{dictionary.BookingRoomFooterInsurance}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    export default {
        name: "roomPriceTable",
        props: ["room", "dictionary"],
        methods: {
        }
    };
</script>
